import { render, staticRenderFns } from "./base-badge.vue?vue&type=template&id=b37b1d44&scoped=true"
import script from "./base-badge.vue?vue&type=script&lang=js"
export * from "./base-badge.vue?vue&type=script&lang=js"
import style0 from "./base-badge.vue?vue&type=style&index=0&id=b37b1d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b1d44",
  null
  
)

export default component.exports